// src/pages/auth/DefinirNovaSenha.tsx
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { apiPut } from '../../services/api';
import { showAlert } from '../../contexts/DialogContext';
import { resolveAuthError } from '../../services/authError';
import AnimatedCanvas from '../../components/common/AnimatedCanvas';
import '../../pages/auth/Login.css';
import logoBluelt from '../../assets/images/logoBluelt.png';
import { logger } from '@/utils/logger';

const DefinirNovaSenha = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    document.body.classList.add('login-page');
    return () => {
      document.body.classList.remove('login-page');
    };
  }, []);

  useEffect(() => {
    document.title = 'Bluelt | Definir Nova Senha';
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!novaSenha || !confirmarSenha) {
      await showAlert('Preencha ambos os campos de senha.', { variant: 'warning' });
      return;
    }
    if (novaSenha !== confirmarSenha) {
      await showAlert('As senhas não coincidem. Tente novamente.', { variant: 'warning' });
      return;
    }
    setIsLoading(true);
    try {
      const response = await apiPut('/v1/password-reset/confirm', { token, newPassword: novaSenha });
      await showAlert(response.data?.message || 'Senha redefinida com sucesso! Faça login.', { variant: 'success' });
      navigate('/login');
    } catch (error) {
      logger.error('Erro ao redefinir senha:', error);
      const { message, variant } = resolveAuthError(error, 'Erro ao redefinir senha. Tente novamente mais tarde.');
      await showAlert(message, { variant });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AnimatedCanvas />
      <div className="auth-container">
        <form id="login-form" onSubmit={handleSubmit} noValidate>
          <img src={logoBluelt} alt="Logo Bluelt" className="logo" />
          <h3>Definir Nova Senha</h3>
          <div className="form-group">
            <input
              type="password"
              placeholder="Digite sua nova senha"
              value={novaSenha}
              onChange={(e) => setNovaSenha(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Confirme sua nova senha"
              value={confirmarSenha}
              onChange={(e) => setConfirmarSenha(e.target.value)}
              required
              disabled={isLoading}
            />
          </div>
          {!isLoading ? (
            <button type="submit" className="btn-submit">Redefinir Senha</button>
          ) : (
            <button type="button" className="btn-clone" disabled>
              <div className="spinner"></div>
            </button>
          )}
          <div className="area-suporte">
            <a className="forgot-link" href="/login">Voltar para o login</a>
          </div>
        </form>
      </div>
    </>
  );
};

export default DefinirNovaSenha;